import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toastr } from "react-redux-toastr";
import { hideModal } from '../../../actions/modal.actions';
import { loadBillingJobs, approveBillingJob } from '../../../actions/billingJobs.actions';
import { getModalData } from '../../../selectors/index';
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";

class BillingJobApproveModal extends Component {

    closeModal = () => {
        this.props.hideModal();
        if (this.props.modalProps.onCloseCallback) {
            this.props.modalProps.onCloseCallback();
        }
    }

    formSubmit = (values, actions) => {
        const { billingJob } = this.props.modalProps;

        const payload = {
            scheduledDateTime: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
            generateInvoices: values.generateInvoices,
        };
        if (values.note) {
            payload.note = values.note;
        }

        this.props.approveBillingJob(billingJob.id, payload)
            .then(result => {
                if (result.success) {
                    toastr.success(`Billing Job #${billingJob.id} has been approved.`, { timeOut: 3000, position: 'top-center' });
                    this.props.loadBillingJobs();
                    this.props.hideModal();
                } else {
                    const message = result.error?.message || result.error?.error || 'An unexpected error occurred.';
                    toastr.error('Approve Billing Failed', message, { timeOut: 5000, position: 'top-center' });
                    actions.setSubmitting(false);
                }
            });
    }

    render() {
        const { modalProps } = this.props;
        const billingJob = (modalProps && modalProps.billingJob) || {};

        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <Formik
                        initialValues={{
                            confirmAction: '',
                            note: '',
                            generateInvoices: true,
                        }}
                        validationSchema={Yup.object().shape({
                            confirmAction: Yup.string().typeError('Required').required('Required').equals(['approve'], 'Value entered must match "approve" exactly.'),
                            note: Yup.string().max(2048, 'Note cannot exceed 2048 characters'),
                        })}
                        onSubmit={this.formSubmit}
                        render={({ handleChange, handleSubmit, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Approve Billing</h5>
                                            <button onClick={this.closeModal} type="button" className="close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>

                                        <div className="modal-body form-horizontal">
                                            <p>
                                                You are about to approve billing job <strong>#{billingJob.id || 'N/A'}</strong> with
                                                invoice date <strong>{billingJob.invoiceDate ? moment(billingJob.invoiceDate).format('MM/DD/YYYY') : 'N/A'}</strong>.
                                                Running Approve Billing will finalize billing for <strong>{billingJob.invoiceDate ? moment(billingJob.invoiceDate).format('MM/DD/YYYY') : 'N/A'}</strong> and will make billing live.
                                            </p>

                                            <div className="form-group">
                                                <span className="h-check" style={{marginLeft: 0, flexDirection: 'row-reverse', gap: '0.5rem'}}>
                                                    <label>Generate Invoices&nbsp;</label>
                                                    <div
                                                        className="form-check checkbox-slider checkbox-slider--b-flat">
                                                        <label>
                                                            <input
                                                                name="generateInvoices"
                                                                type="checkbox"
                                                                onBlur={handleBlur}
                                                                onChange={() => setFieldValue('generateInvoices', !values.generateInvoices)}
                                                                checked={values.generateInvoices}
                                                            />
                                                            <span>&nbsp;</span>
                                                        </label>
                                                    </div>
                                                </span>
                                            </div>

                                            <div className="form-group">
                                                <label>Type "approve" to continue</label>
                                                <input
                                                    name="confirmAction"
                                                    className={"form-control" + (touched.confirmAction && errors.confirmAction ? " is-invalid" : "")}
                                                    placeholder="approve"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.confirmAction}
                                                    autoComplete="off"
                                                    style={touched.confirmAction && errors.confirmAction ? {backgroundImage: 'none'} : undefined}
                                                />
                                                {touched.confirmAction && errors.confirmAction &&
                                                    <div className="invalid-feedback">{errors.confirmAction}</div>
                                                }
                                            </div>

                                            <div className="form-group">
                                                <label>Note <span className="text-muted">(optional)</span></label>
                                                <textarea
                                                    name="note"
                                                    className={"form-control" + (touched.note && errors.note ? " is-invalid" : "")}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.note}
                                                    rows={3}
                                                    maxLength={2048}
                                                />
                                                {touched.note && errors.note &&
                                                    <div className="invalid-feedback">{errors.note}</div>
                                                }
                                            </div>
                                        </div>

                                        <div className="modal-footer">
                                            <button onClick={this.closeModal} className="btn btn-secondary" type="button">
                                                Cancel
                                            </button>
                                            <button disabled={isSubmitting} type="submit" className="btn btn-primary">
                                                Approve Billing
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps;
    return {
        modalProps,
    };
};

const mapDispatchToProps = {
    hideModal,
    approveBillingJob,
    loadBillingJobs,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingJobApproveModal);
